import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconToast: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="toast, breakfest"><path d="M12 3C9.34018 3 6.89523 3.6103 5.08906 4.63542C3.30507 5.64796 2 7.16238 2 9C2 10.4383 2.80469 11.683 4 12.6342V19.25C4 20.2165 4.7835 21 5.75 21H18.25C19.2165 21 20 20.2165 20 19.25V12.6342C21.1953 11.683 22 10.4383 22 9C22 7.16238 20.6949 5.64796 18.9109 4.63542C17.1048 3.6103 14.6598 3 12 3Z" fill="currentColor"/></CentralIconBase>;
};

export default IconToast;
